import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserModule } from '@angular/platform-browser';
import { BaseChartDirective } from "ng2-charts";

import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { ResourceComponent } from './resource.component';
import { ResourcePricingComponent } from "app/modules/resource/resource-pricing.component";
import { ResourcePlanningComponent } from './resource-planning.component';
import { ResourceNewsletterComponent } from './resource-newsletter.component';

@NgModule({
    imports: [
        BrowserModule,
        NWMControls,
        NgbModule,
        BaseChartDirective,
        FormsModule,
        ResourceNewsletterComponent,
        ResourcePlanningComponent,
        ResourceComponent,
        ResourcePricingComponent,
    ],
    providers: []
})
export class ResourceModule { }
